import { createStore } from 'vuex'

export default createStore({
    state: {
        games: [],
        users: [],
        selectedCard: null,
        revealed: false
    },
    mutations: {
        UPDATE_GAMES(state, payload) {
            state.games = payload
        },
        UPDATE_USERS(state, payload) {
            state.users = payload
        },
        SET_SELECTED_CARD(state, payload) {
            state.selectedCard = payload
        },
        SET_REVEALED(state, payload) {
            state.revealed = payload
            // Kept in the session so the votes stay shown when the page is refreshed.
            sessionStorage.setItem('revealed', payload)
        },
        SET_ADMIN(state, name) {
            const user = state.users.find(u => u.name == name);
            if (user) {
                user.admin = true;
            }
        },
        RESET_GAME(state) {
            state.users = []
            state.selectedCard = null
            state.revealed = false
            sessionStorage.removeItem('revealed')
        },
        SET_USER_VOTED(state, { name, gameId, value }) {
            const user = state.users.find(u => u.name == name && u.gameId == gameId);
            if (user) {
                user.hasVoted = true;
                if (value !== undefined) {
                    user.value = value;
                }
            }
        },
        RESET_VOTES(state) {
            state.users = state.users.map(user => ({ ...user, value: '', hasVoted: false }))
            state.selectedCard = null
            state.revealed = false
            sessionStorage.setItem('revealed', false)
        }
    },
    actions: {
        addToGames(context, payload) {
            var game = context.state.games.concat(JSON.parse(payload));
            context.commit('UPDATE_GAMES', game)
        },
        addToUsers(context, payload) {
            var users = context.state.users.concat(JSON.parse(payload));
            context.commit('UPDATE_USERS', users);
        },
        removeToUsers(context, user) {
            var users = context.state.users;
            user = JSON.parse(user);
            var userRetrieved = this.getters.getUserByNameAndGameId(user.name, user.gameId)
            if (userRetrieved != undefined) {
                var index = users.map(function (e) {
                    return e.name;
                }).indexOf(user.name);
                users.splice(index, 1);
                context.commit('UPDATE_USERS', users);
            }
        },
    },
    getters: {
        votedCount: (state) => {
            return state.users.filter(user => state.revealed ? !!user.value : user.hasVoted).length;
        },
        getCurrentGame: (state) => (id) => {
            return state.games.find(game => game.id === id);
        },
        existUser: (state) => (gameId, name) => {
            var exist = false;
            state.users.forEach(function (user) {
                if (user.name == name && user.gameId == gameId) {
                    exist = true;
                }
            });
            return exist;
        },
        getUserByNameAndGameId: (state) => (name, gameId) => {
            var userFound;
            state.users.forEach(function (user) {

                if (user.name == name && user.gameId == gameId) {
                    userFound = user;
                }
            });
            return userFound;
        },
        userIsAdmin: (state) => (gameId, name) => {
            var isAdmin = false;
            state.users.forEach(function (user) {

                if (user.name == name && user.gameId == gameId && user.admin == true) {
                    isAdmin = true;
                }
            });
            return isAdmin;
        },
    },
})